import { useForm } from "features/shared/forms/hooks/useForm";
import React from "react";
import FormGroup from "features/shared/forms/components/FormGroup";
import ModalFooter from "features/shared/components/modal/ModalFooter";
import { mailMethodEmailSubDialogValidations } from "./mailMethodEmailSubDialogValidation";
import { useTranslation } from "react-i18next";

type Props = {
  onSubmit: (email: string) => void;
  mailMethodEmails: string[];
};

const MailMethodEmailSubDialog = ({ onSubmit, mailMethodEmails }: Props) => {
  //translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // form hook
  const {
    getFormValue,
    bindFieldNew,
    errors,
    valideteForm,
    clearForm,
    setValidationError,
  } = useForm({
    initialValidations: mailMethodEmailSubDialogValidations(),
  });

  // helpers
  const validateForm = () => {
    if (valideteForm()) {
      const filledEmail = getFilledEmail();

      if (mailMethodEmails.find((email) => email === filledEmail)) {
        setValidationError("email", "Zadaný email již byl přidán.");
      } else {
        return true;
      }
    }

    return false;
  };

  const getFilledEmail = () => { 
    return getFormValue<string>("email");
  }

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (validateForm()) {
      onSubmit(getFilledEmail());
      clearForm();
    }
  };

  // render
  return (
    <form onSubmit={submitFormHandler}>
      <div className="modal-body py-4">
        <FormGroup
          labelText={tLabels("mailMethodEmailSubDialog.email.label")}
          inputId="email"
          validationError={errors["email"]}
        >
          <input
            id="email"
            className="form-control"
            placeholder={tLabels("mailMethodEmailSubDialog.email.placeholder")}
            {...bindFieldNew("email")}
          />
        </FormGroup>
      </div>
      <ModalFooter>
        <button type="submit" className="btn btn-primary">
          {tLabels("mailMethodEmailSubDialog.addEmail")}
        </button>
      </ModalFooter>
    </form>
  );
};

export default MailMethodEmailSubDialog;
